import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const leagueTypePlaceholderOuter = style({
  display: "grid",
  gap: vars.space.l,
});
